import NewsArticle from './news-article';

export { NewsArticle }